import { RouterManager } from '@aclass/admin/managers';
import { ExceptionStory } from '@aclass/admin/storage/actions';
import { IAdminState, IExceptionModuleState } from '@aclass/admin/storage/states';
import { BaseResolver } from '@aclass/core/resolvers/base.resolver';
import { NgRedux } from '@angular-redux/store';
import { Injectable } from '@angular/core';
import { filter } from 'rxjs/operators';

@Injectable()
export class ExceptionSearchStateResolver extends BaseResolver {

    static STOP_EVENT_NAME = 'stop:exception-search';

    constructor(
        private ngRdx: NgRedux<IAdminState>,
        private routerManager: RouterManager
    ) {
        super();
        this.resolver = this.ngRdx.select<IExceptionModuleState['searchPageInitialized']>(['exceptionModule', 'searchPageInitialized']).pipe(
            filter(v => v)
        );
        this.employee = this.routerManager.onRejectNavigation(ExceptionSearchStateResolver.STOP_EVENT_NAME);
    }

    /**
     * @inheritDoc
     */
    beforeResolve(): void {
        this.ngRdx.dispatch(ExceptionStory.dryRunSearchPage());
    }
}
